import * as React from "react";
import { connect } from "react-redux";
import {
  getFlightMarkersState,
  getGCPRequestState,
  getSiteState,
  IStoreState,
} from "../../../redux/rootReducer";
import Dropdown from "./Dropdown";
import config from "../../../config";
import { IGcpAppDispatch } from "../../../redux/store";
import {
  createGcpRequestCsvAllInWgs,
  createGcpRequestCsvProblemInWgs,
} from "../../../redux/computables/csvFile/csvFile";
import {
  userDownloadsAllCsvWgs,
  userDownloadsRequestedCsvWgs,
} from "./scenarios";

interface ICsvWgsDownloadButtonProps {
  csvFileAll: string;
  csvFileProblem: string;
  dispatch: IGcpAppDispatch;
}

const CsvWgsDownloadButton = ({
  dispatch,
  csvFileAll,
  csvFileProblem,
}: ICsvWgsDownloadButtonProps) => (
  <Dropdown
    label="CSV (WGS84)"
    icon={<img src="icon-download.svg" />}
    options={[
      {
        label:
          config.language === "ru"
            ? "Все опознаки (WGS84)"
            : "All Flight Markers (WGS84)",
        onClick: () => {
          dispatch(userDownloadsAllCsvWgs(csvFileAll));
        },
      },
      {
        label:
          config.language === "ru"
            ? "Запрошенные опознаки (WGS84)"
            : "Requested Flight Markers (WGS84)",
        onClick: () => {
          dispatch(userDownloadsRequestedCsvWgs(csvFileProblem));
        },
      },
    ]}
  />
);

export default connect((state: IStoreState) => ({
  csvFileAll: createGcpRequestCsvAllInWgs(
    getGCPRequestState(state),
    getFlightMarkersState(state),
    getSiteState(state),
  ),
  csvFileProblem: createGcpRequestCsvProblemInWgs(
    getGCPRequestState(state),
    getFlightMarkersState(state),
    getSiteState(state),
  ),
}))(CsvWgsDownloadButton);
